import React from "react";
import { TextField } from "@mui/material";

const PersonNameWidget = ({
  id,
  label,
  value,
  required,
  disabled,
  readonly,
  autofocus,
  onChange,
  onBlur,
  schema,
  rawErrors = [],
}) => {
  return (
    <TextField
      id={id}
      label={label}
      value={value ?? ""}
      required={required}
      disabled={disabled}
      inputProps={{
        readOnly: readonly,
        autoFocus: autofocus,
        maxLength: schema.maxLength,
      }}
      onChange={(event) => {
        onChange(event.target.value);
      }}
      onBlur={(event) => onBlur?.(id, event.target.value)}
      fullWidth
      error={rawErrors.length > 0}
    />
  );
};

export default PersonNameWidget;
